import React from 'react'
import { Link } from "react-scroll";

//RESOURCES LINKS
import logo from '../img/universefullv2.png';
import burgerIcon from '../img/hamburger.svg'


class NavbarComponent extends React.Component {
    constructor(props) {
        super();
        this.state = { 
                "navState": {
                'indx-1': true,
                'indx-2': false,
                'indx-3': false,
                'indx-4': false,
                'indx-5': false
            }
        };
        
        this.toggleActiveclass = this.toggleActiveclass.bind(this);
    }

    toggleActiveclass = (index) => (event) => {
        let newNavState = this.state['navState'];
        
        //set all nav state to false
        Object.keys(newNavState).forEach((elem_indx) => { 
            newNavState[elem_indx] = false;   
        });

        //set the clicked nav to true
        newNavState[index] = true;

        //creates new state
        this.setState({
            "navState": newNavState
        });
    }//end fn

    render() {
        return (
            <nav class="navbar navbar-expand-lg fixed-top" id="mainNav">
                <div class="container-fluid">
                    <a class="navbar-brand js-scroll-trigger" href="#page-top">
                        <img src={logo} />
                    </a>
                    <a class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                        <img src={burgerIcon} />
                    </a>
                    <div class="collapse navbar-collapse" id="navbarResponsive">
                        <ul class="navbar-nav">
                            <li class="nav-item">
                                <Link activeClass="g" className={`nav-link js-scroll-trigger ${this.state['navState']["indx-1"] ? "active" : ""}`} to="about" spy={true} smooth={true} offset={-50} duration={400} onClick={this.toggleActiveclass('indx-1')}>
                                    About Us
                                </Link>
                            </li>
                            <li class="nav-item">
                                <Link activeClass="g" className={`nav-link js-scroll-trigger ${this.state['navState']["indx-2"] ? "active" : ""}`} to="benefits" spy={true} smooth={true} offset={-50} duration={400} onClick={this.toggleActiveclass('indx-2')}>
                                    Why Us?
                                </Link>
                            </li>
                            <li class="nav-item">
                                <Link activeClass="g" className={`nav-link js-scroll-trigger ${this.state['navState']["indx-3"] ? "active" : ""}`} to="reqs" spy={true} smooth={true} offset={-50} duration={400} onClick={this.toggleActiveclass('indx-3')}>
                                    Contact Us
                                </Link>
                            </li>
                            <li class="nav-item">
                                <Link activeClass="g" className={`nav-link js-scroll-trigger ${this.state['navState']["indx-4"] ? "active" : ""}`} to="pricing" spy={true} smooth={true} offset={-50} duration={400} onClick={this.toggleActiveclass('indx-4')}>
                                    Find Us
                                </Link>
                            </li>
                            <li class="nav-item">
                                <Link activeClass="g" className={`nav-link js-scroll-trigger ${this.state['navState']["indx-5"] ? "active" : ""}`} to="faq" spy={true} smooth={true} offset={-50} duration={400} onClick={this.toggleActiveclass('indx-5')}>
                                    FAQs
                                </Link>
                            </li>
                        </ul>
                    </div>
                    {/*<div class="sign-in">
                        <button class="bt bt-signin" data-toggle="modal" data-target="#signin">Sign In</button>
                    </div>*/}
                </div>
            </nav>
        );
    }
}//end class

export { NavbarComponent };
